<script setup>
defineProps({
  active: Boolean,
  href: [String, Boolean],
  title: {
    type: String,
    required: false,
    default: ''
  }
});
</script>
<template>
  <div
    class="text-background-content cursor-pointer rounded-lg border border-transparent px-4 py-2.5 transition duration-300"
    :class="{
      'hover:bg-tab-hover': !active,
      'bg-button text-button-content! border': active
    }"
  >
    {{ title }}
    <slot />
  </div>
</template>
